<template>
  <div id="misc">
    <img
      class="misc-mask"
      height="226"
      :src="require(`@/assets/images/misc/misc-mask-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
    />

    <div class="page-title text-center px-4">
      <h2 class="text-2xl font-weight-semibold text--primary d-flex align-center justify-center">
        <span class="me-2">  ليس لديك صلاحية وصول </span>
        <v-icon color="warning">
          mdi-lock
        </v-icon>
      </h2>
      <p class="text-sm">
        ربما احطأت في كتابة  عنوان الصفحة او تم  حجب الوصول عنك
      </p>

      <div class="misc-character d-flex justify-center">
        <v-img
          max-width="700"
          height="500"
          src="@/assets/images/error/403.png"
        ></v-img>
      </div>

      <v-btn
        color="primary"
        to="/"
        class="mb-4"
      >
        رجوع
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mdiAlert, mdiLock } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiAlert,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/misc.scss';
</style>
